<div class="h-100 w-100">

    <img *ngIf="stream.hasAudio" src="./assets/images/video-call/component218.png"

         srcset="./assets/images/video-call/component218@2x.png 2x,

             ./assets/images/video-call/component218@3x.png 3x"

         class="Component-218">
    <img *ngIf="!stream.hasAudio" src="./assets/images/video-call/component176.png"

         srcset="./assets/images/video-call/component176@2x.png 2x,

             ./assets/images/video-call/component176@3x.png 3x"

         class="Component-218">
  <div class="h-100 w-100 mrneg40" #subscriberDiv></div>
</div>
